/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
//
// Default text theme

import { KaryaTextTheme } from '../TextVariants';

type TextTheme = {
  [key: string]: {
    fontSize: string;
    fontWeight: number;
    letterSpacing: string;
    lineHeight: string;
  };
};

const fontWeightMap: Record<string, number> = {
  Bold: 700,
  Semibold: 600,
  Medium: 500,
  Regular: 400,
};

export const textThemeGenerator = (
  variant: string,
  fontSize: string,
  letterSpacing: string,
  lineHeight: string,
): TextTheme => {
  const weights = ['Bold', 'Semibold', 'Medium', 'Regular'];
  return weights.reduce((acc: TextTheme, weight) => {
    acc[`${variant}/${weight}`] = {
      fontSize,
      fontWeight: fontWeightMap[weight],
      letterSpacing,
      lineHeight,
    };
    return acc;
  }, {});
};

export const textTheme: KaryaTextTheme = {
  ...textThemeGenerator('DisplayMedium', '4.5rem', '-0.5%', '130%'),
  ...textThemeGenerator('DisplaySmall', '4rem', '-0.5%', '130%'),
  ...textThemeGenerator('HeadingLarge', '3.5rem', '0%', '140%'),
  ...textThemeGenerator('HeadingMedium', '3rem', '0%', '140%'),
  ...textThemeGenerator('HeadingSmall', '2.5rem', '0.25%', '140%'),
  ...textThemeGenerator('TitleLarge', '2rem', '0.25%', '140%'),
  ...textThemeGenerator('TitleMedium', '1.5rem', '0%', '140%'),
  ...textThemeGenerator('TitleSmall', '1.25rem', '0.15%', '140%'),
  ...textThemeGenerator('BodytextDefault', '1rem', '0.5%', '140%'),
  ...textThemeGenerator('BodytextSmall', '0.875rem', '0.25%', '140%'),
  ...textThemeGenerator('Captions', '0.75rem', '0.4%', '140%'),
};
